const THOUSAND = 1000;

const roundToThousandth = (value) => Math.round((value + Number.EPSILON) * THOUSAND) / THOUSAND;

export const isValidPointsGroup = (rank, groupSize) => (
  Number.isInteger(rank) &&
  Number.isInteger(groupSize) &&
  rank >= 1 &&
  groupSize >= 1 &&
  rank <= groupSize
);

export const creditedGroupSize = (groupSize) => {
  if (!Number.isInteger(groupSize) || groupSize < 1) return null;

  return Math.ceil(groupSize * 0.9);
};

export const groupPoints = (rank, groupSize) => {
  if (!isValidPointsGroup(rank, groupSize)) return null;

  const creditedSize = creditedGroupSize(groupSize);
  const points = Math.max(0, (1 - rank / (creditedSize + 1)) * 100);

  return roundToThousandth(points);
};

export const combinedPoints = ({
  categoryRank,
  categorySize,
  genderRank,
  genderSize
}) => {
  const categoryPoints = groupPoints(categoryRank, categorySize);
  const genderPoints = groupPoints(genderRank, genderSize);

  if (categoryPoints === null || genderPoints === null) return null;

  return roundToThousandth(categoryPoints * 0.33 + genderPoints * 0.67);
};

export const formatPoints = (points) => points === null ? '—' : points.toFixed(3);

export const weightedContribution = (points, weight) => (
  points === null ? null : points * weight
);

export const formatContribution = (contribution) => (
  contribution === null ? '—' : contribution.toFixed(5)
);
